/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserMessageControllerService {
    /**
     * @param propertyId
     * @param formData Message content and optional file upload
     * @returns any Message and/or attachments sent successfully
     * @throws ApiError
     */
    public static userMessageControllerSendMessage(
        propertyId: string,
        formData?: {
            message?: string;
            files?: Array<Blob>;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/users/message/{propertyId}',
            path: {
                'propertyId': propertyId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
}
